import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import Toast from "vue-toastification";
import "./assets/js/util";
import "vue-toastification/dist/index.css";
import "remixicon/fonts/remixicon.css";
import "../node_modules/vue-multiselect/dist/vue-multiselect.css";

const pinia = createPinia();
const appInstance = createApp(App);
appInstance.use(pinia);
appInstance.use(store);
appInstance.use(router);
appInstance.use(Toast);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
